// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4084":"8b818b40","7680":"22c1d713"}[chunkId] + ".css";
};